module.exports = __webpack_public_path__ + "media/images/emblems/Schwadernau-coat_of_arms-75c8afc73bce24cf2be394d226e9504e.svg";